import { makeStyles } from "tss-react/mui";
import { Button, ButtonGroup, Grow, Link, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DoubleArrowRoundedIcon from "@mui/icons-material/DoubleArrowRounded";
import React from "react";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

const useStyles = makeStyles()({
  /**
   * Filter ribbon styles
   **/
  tileCard: {
    paddingBottom: 0,
    margin: 5,
    display: "flex",
    borderRadius: 10,
    boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
    opacity: 0.7,
    "&:hover": {
      opacity: 1,
    },
  },
  ribbonLabelText: {
    textAlign: "center",
    transition: "0.2s",
    height: 30,
    position: "absolute",
    padding: "4px 0px",
    transform: "translateY(-30px)",
  },
  verticalLine: {
    height: "20%",
    backgroundColor: "rgb(215, 215, 215)",
    width: 3,
    margin: "20px auto",
    borderRadius: 4,
  },
  tileDefaultStyle: {
    backgroundPosition: "center",
    overflow: "hidden",
    position: "relative",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
    backgroundColor: "#333333",
    borderRadius: "0px 0px 10px 10px",
    "&:hover": {
      boxShadow: " rgba(149, 157, 165, 0.5) 0px 8px 24px",
    },
  },
  AreaButtonIndex: {
    borderRadius: 100,
    padding: "0px 5px",
    margin: "auto",
    fontSize: 10,
  },
  areaButton: {
    zIndex: 3,
    position: "fixed",
    "&:hover .makeStyles-descriptionBox-230": {
      display: "block",
    },
  },
  areaDescription: {
    width: 200,
    padding: 15,
    textTransform: "none",
    borderRadius: 50,
  },
  descriptionBox: {
    display: "none",
    position: "absolute",
    transform: "translateY(5px)",
    pointerEvents: "none",
  },
  changeFilterButton: {
    display: "flex",
    height: 30,
    color: "white",
    textAlign: "center",
    padding: "0px 10px",
    margin: "auto",
  },
});

export function FilterRibbon({
  showAllText = true,
  allSelectedFilterText = "Show all", //Text on the first "NO FILTER" tile if no image is put inside the JSON (type: string)
  inactiveAreaColor = "#FF0000", //Hexadecimal color code of the areas you don't want to show (type: string)
  inactiveAreas, //List of screenIndexes you don't want to show (type: list / JSON)
  ribbonComponents, //JSON with screen information (IMPORTANT) (type: JSON)
  changeSelector, //Function that changes and gives the value of the screenIndex of the selected tile (IMPORTANT) (type: function)
  selectedGroupVal, //The value of screenIndex from the selected tile (IMPORTANT) (type: string)
  colorGroup1Background = "#f46e26", //Hexadecimal color code of the background of colorGroup1 (type: string)
  colorGroup1Foreground = "#ffffff", //Hexadecimal color code of the foreground of colorGroup1 (type: string)
  colorGroup2Background = "#ffffff", //Hexadecimal color code of the background of colorGroup2 (type: string)
  colorGroup2Foreground = "#000000", //Hexadecimal color code of the foreground of colorGroup2 (type: string)
  colorGroup3Background = "#f46e26", //Hexadecimal color code of the background of colorGroup3 (type: string)
  colorGroup3Foreground = "#ffffff", //Hexadecimal color code of the foreground of colorGroup3 (type: string)
  areaHighlightBackground = "#000000", //Hexadecimal color code of the highlight around the selected area button after selection (type: string)
  areaHighlightBackgroundOpacity = 175, //Opacity value of highlight around selected area button after selection (value: 0 to 255) (type: number)
  areaOpacity = 100, //Opacity value of area button (value: 0 to 255) (type: number)
  shownDescription = "bottom", //Description type (description types: "bottom (default)", "side", "none") (type: string)
  showAdminInfo = false, //If true all screenIndexes will be shown (type: boolean)
  showBreadcrumbs = true, //If true the breadcrumb menu will be shown (type: boolean)
  showFilterReturnButton = true, //If true the "FILTER" button will be shown with the return button next to it (type: boolean)
  showHoverDescription = true, //If true a description will be shown while hovering over an area (type: boolean)
}) {
  const { classes } = useStyles();

  //If colorGroup has no value from props, it will use the previous colorGroup
  let colorGroup1BackgroundString = colorGroup1Background;
  let colorGroup1ForegroundString = colorGroup1Foreground;
  let colorGroup2BackgroundString = colorGroup2Background;
  let colorGroup2ForegroundString = colorGroup2Foreground;
  let colorGroup3BackgroundString = colorGroup3Background;
  let colorGroup3ForegroundString = colorGroup3Foreground;

  if (!colorGroup2BackgroundString) colorGroup2BackgroundString = colorGroup1BackgroundString;
  if (!colorGroup2ForegroundString) colorGroup2ForegroundString = colorGroup1ForegroundString;

  if (!colorGroup3BackgroundString) colorGroup3BackgroundString = colorGroup2BackgroundString;
  if (!colorGroup3ForegroundString) colorGroup3ForegroundString = colorGroup2ForegroundString;

  let defaultStyle = { display: "flex", flexWrap: "wrap" };

  let screenAmount = ribbonComponents.length;

  return (
    <>
      <div
        id={"selectionRibbonContainer"}
        style={
          window.matchMedia("(min-width: 3000px)").matches
            ? {
                zoom: 3000 / 1920,
                ...defaultStyle,
              }
            : window.matchMedia("(min-width: 1920px)").matches
              ? {
                  zoom: window.innerWidth / 1920,
                  ...defaultStyle,
                }
              : window.matchMedia("(max-width: 1920px)").matches
                ? {
                    zoom: 1,
                    ...defaultStyle,
                  }
                : null
        }
      >
        {ribbonComponents.map((screens) => (
          <div
            className={classes.tileCard}
            key={screens.screenIndex}
            style={
              screens.screenIndex === selectedGroupVal.charAt(0)
                ? {
                    opacity: 1,
                    maxHeight: screens.screenHeight + 65,
                    backgroundColor: colorGroup2BackgroundString,
                    borderTop: "30px solid " + colorGroup1BackgroundString,
                    marginBottom: 27,
                  }
                : selectedGroupVal === "none" && screens.screenIndex === "none"
                  ? {
                      opacity: 1,
                      maxHeight: screens.screenHeight + 65,
                      backgroundColor: colorGroup2BackgroundString,
                      borderTop: "30px solid " + colorGroup1BackgroundString,
                      marginBottom: 30,
                    }
                  : {
                      maxHeight: screens.screenHeight + 30,
                      backgroundColor: colorGroup2BackgroundString,
                      borderTop: "30px solid " + colorGroup1Foreground,
                      marginBottom: 30,
                    }
            }
          >
            <FilterRibbonFunction
              allSelectedFilterText={allSelectedFilterText}
              areaHighlightBackground={areaHighlightBackground}
              areaHighlightBackgroundOpacity={areaHighlightBackgroundOpacity}
              areaOpacity={areaOpacity}
              colorGroup1Background={colorGroup1BackgroundString}
              colorGroup1Foreground={colorGroup1ForegroundString}
              colorGroup2Background={colorGroup2BackgroundString}
              colorGroup2Foreground={colorGroup2ForegroundString}
              colorGroup3Background={colorGroup3BackgroundString}
              colorGroup3Foreground={colorGroup3ForegroundString}
              inactiveAreaColor={inactiveAreaColor}
              inactiveAreas={inactiveAreas}
              parentImg={screens.screenImage}
              screenAmount={screenAmount}
              screens={screens}
              selector={selectedGroupVal}
              selectorFunction={changeSelector}
              showAdminInfo={showAdminInfo}
              showAllText={showAllText}
              showFilterReturnButton={showFilterReturnButton}
              showHoverDescription={showHoverDescription}
              shownDescription={shownDescription}
            />
          </div>
        ))}
      </div>

      {shownDescription === "bottom" || showAdminInfo
        ? ribbonComponents.map((screens) => (
            <DescriptionComponent
              colorGroup1Background={colorGroup1Background}
              colorGroup1Foreground={colorGroup1Foreground}
              screenAmount={screenAmount}
              screens={screens}
              selector={selectedGroupVal}
              showAdminInfo={showAdminInfo}
            />
          ))
        : null}

      {showBreadcrumbs && selectedGroupVal !== "none" ? (
        <div style={{ marginBottom: 10, display: "flex" }}>
          <p style={{ color: "#f7844a", fontSize: "1rem", marginRight: 15, marginLeft: 15 }}>Filter: </p>
          {ribbonComponents.map((screens) => (
            <div key={screens.screenIndex} style={{ display: "flex" }}>
              <FilterRibbonBreadcrumbMenuComponent
                screens={screens}
                selector={selectedGroupVal}
                selectorFunction={changeSelector}
              />
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
}

//SELECTION RIBBON
function FilterRibbonFunction({
  showAllText,
  inactiveAreaColor,
  allSelectedFilterText,
  inactiveAreas,
  areaHighlightBackground,
  areaHighlightBackgroundOpacity,
  areaOpacity,
  colorGroup1Background,
  colorGroup1Foreground,
  colorGroup2Background,
  colorGroup2Foreground,
  colorGroup3Background,
  colorGroup3Foreground,
  parentImg,
  screenAmount,
  screens,
  selector,
  selectorFunction,
  showAdminInfo,
  showFilterReturnButton,
  showHoverDescription,
  shownDescription,
}) {
  const { classes } = useStyles();
  const screenExists = screens.hasOwnProperty("subScreenInfo");

  let screenIndex = screens.screenIndex;
  let descriptionWidth =
    (selector.length - 1) * 20 + screens.screenWidth * (screenAmount + (selector.length - 1)) + 10 * screenAmount;

  return (
    <>
      {screenIndex.length > 1 && selector === screenIndex && selector !== "none" ? (
        <Grow in={true}>
          <div>
            <div className={classes.verticalLine} />
            <ArrowDropDownIcon fontSize={"small"} style={{ transform: "rotate(-90deg)" }} />
            <div className={classes.verticalLine} />
          </div>
        </Grow>
      ) : null}
      {screenIndex.length === 1 || screenIndex === selector.substr(0, screenIndex.length) || screenIndex === "none" ? (
        <>
          <div>
            <Typography
              className={classes.ribbonLabelText}
              onClick={() => {
                selectorFunction(screenIndex);
              }}
              style={
                screenIndex === selector.substr(0, screenIndex.length) && screenIndex.length !== selector.length
                  ? {
                      color: colorGroup1Foreground,
                      opacity: 0.5,
                      width: screens.screenWidth,
                      cursor: "pointer",
                    }
                  : screenIndex === selector.substr(0, screenIndex.length) && screenIndex.length === selector.length
                    ? {
                        color: colorGroup1Foreground,
                        width: screens.screenWidth,
                      }
                    : {
                        color: colorGroup1Background,
                        width: screens.screenWidth,
                        cursor: "pointer",
                      }
              }
            >
              {screens.screenTitle}
            </Typography>
            <div
              className={classes.tileDefaultStyle}
              onClick={() => {
                if (screenIndex !== selector) {
                  selectorFunction(screens.screenIndex);
                }
              }}
              style={
                screenIndex === selector && screens.screenImage === ""
                  ? {
                      opacity: 1,
                      backgroundImage: "url(" + parentImg + ")",
                      height: screens.screenHeight,
                      width: screens.screenWidth,
                    }
                  : screenIndex === selector && screens.screenImage !== ""
                    ? {
                        opacity: 1,
                        backgroundImage: "url(" + screens.screenImage + ")",
                        height: screens.screenHeight,
                        width: screens.screenWidth,
                      }
                    : screenIndex !== selector && screenIndex.charAt(0) === selector.charAt(0) && selector.length > 2
                      ? {
                          opacity: 0.75,
                          backgroundImage: "url(" + screens.screenImage + ")",
                          cursor: "pointer",
                          marginRight: 10,
                          height: screens.screenHeight,
                          width: screens.screenWidth,
                        }
                      : {
                          opacity: 0.75,
                          backgroundImage: "url(" + screens.screenImage + ")",
                          cursor: "pointer",
                          height: screens.screenHeight,
                          width: screens.screenWidth,
                        }
              }
            >
              <div
                style={{
                  width: screens.screenWidth,
                  height: screens.areaPositionY,
                  backgroundColor: areaHighlightBackground + areaHighlightBackgroundOpacity.toString(16),
                  position: "absolute",
                }}
              />
              <div
                style={{
                  width: screens.areaPositionX,
                  height: screens.areaHeight,
                  transform: "translateY(" + screens.areaPositionY + "px)",
                  backgroundColor: areaHighlightBackground + areaHighlightBackgroundOpacity.toString(16),
                  position: "absolute",
                }}
              />
              <div
                style={{
                  width: screens.screenWidth - (screens.areaPositionX + screens.areaWidth),
                  height: screens.areaHeight,
                  transform:
                    "translate(" + (screens.areaPositionX + screens.areaWidth) + "px, " + screens.areaPositionY + "px)",
                  backgroundColor: areaHighlightBackground + areaHighlightBackgroundOpacity.toString(16),
                  position: "absolute",
                }}
              />
              {screenExists && screenIndex === selector.substr(0, screenIndex.length)
                ? screens.subScreenInfo.map((buttons) => {
                    let buttonIndex = buttons.screenIndex.slice(-1);

                    return (
                      <div key={buttons.screenIndex} style={{ display: "flex" }}>
                        <Button
                          className={classes.areaButton}
                          onClick={() => {
                            selectorFunction(buttons.screenIndex);
                          }}
                          style={
                            selector.match(buttons.screenIndex)
                              ? {
                                  backgroundColor: colorGroup3Background + areaOpacity.toString(16),
                                  width: buttons.areaWidth,
                                  height: buttons.areaHeight,
                                  transform:
                                    "translate(" + buttons.areaPositionX + "px, " + buttons.areaPositionY + "px)",
                                  border: "5px solid " + colorGroup3Background,
                                  color: colorGroup2Foreground,
                                  minWidth: "auto",
                                }
                              : !selector.match(buttons.screenIndex) && screenIndex.length < selector.length
                                ? {
                                    //display none; to hide element immediately
                                    opacity: 0,
                                    backgroundColor: colorGroup3Background + areaOpacity.toString(16),
                                    width: buttons.areaWidth,
                                    height: buttons.areaHeight,
                                    transform:
                                      "translate(" + buttons.areaPositionX + "px, " + buttons.areaPositionY + "px)",
                                    border: "2px solid " + colorGroup3Background,
                                    color: colorGroup2Foreground,
                                    minWidth: "auto",
                                  }
                                : inactiveAreas && inactiveAreas.indexOf(buttons.screenIndex) > -1 && !showAdminInfo
                                  ? {
                                      display: "none",
                                    }
                                  : inactiveAreas && inactiveAreas.indexOf(buttons.screenIndex) > -1 && showAdminInfo
                                    ? {
                                        backgroundColor: inactiveAreaColor + areaOpacity.toString(16),
                                        width: buttons.areaWidth,
                                        height: buttons.areaHeight,
                                        pointerEvents: "none",
                                        transform:
                                          "translate(" + buttons.areaPositionX + "px, " + buttons.areaPositionY + "px)",
                                        border: "2px solid " + inactiveAreaColor,
                                        color: colorGroup2Foreground,
                                        minWidth: "auto",
                                      }
                                    : {
                                        backgroundColor: colorGroup3Background + areaOpacity.toString(16),
                                        width: buttons.areaWidth,
                                        height: buttons.areaHeight,
                                        transform:
                                          "translate(" + buttons.areaPositionX + "px, " + buttons.areaPositionY + "px)",
                                        border: "2px solid " + colorGroup3Background,
                                        color: colorGroup2Foreground,
                                        minWidth: "auto",
                                      }
                          }
                          variant={"contained"}
                        >
                          {showAdminInfo ? (
                            <p className={classes.AreaButtonIndex} style={{ backgroundColor: colorGroup2Background }}>
                              {buttonIndex}
                            </p>
                          ) : null}
                          {showHoverDescription &&
                          buttons.hasOwnProperty("screenDescription") &&
                          screenIndex === selector ? (
                            <div
                              className={classes.descriptionBox}
                              style={{
                                transform: "translateX(" + (screens.screenWidth + 10).toString() + "px)",
                                left: -buttons.areaPositionX,
                              }}
                            >
                              <ArrowDropDownIcon
                                style={{
                                  transform: "translateX(-120px) rotate(90deg)",
                                  position: "absolute",
                                  fontSize: 40,
                                  color: colorGroup3Background,
                                  height: "100%",
                                }}
                              />
                              <Typography
                                className={classes.areaDescription}
                                style={{
                                  backgroundColor: colorGroup3Background,
                                  color: colorGroup3Foreground,
                                }}
                              >
                                {showAdminInfo ? <strong>[{buttons.screenIndex}]</strong> : null}{" "}
                                <TranslationWrapper
                                  tDefault={buttons.screenDescription}
                                  tKey={`CustomComponents_SortingRibbon.${buttons.screenDescription}`}
                                />
                              </Typography>
                            </div>
                          ) : null}
                        </Button>
                      </div>
                    );
                  })
                : null}
              <div
                style={{
                  width: screens.screenWidth,
                  height: screens.screenHeight - screens.areaPositionY - screens.areaHeight,
                  transform: "translateY(" + (screens.areaPositionY + screens.areaHeight) + "px)",
                  backgroundColor: areaHighlightBackground + areaHighlightBackgroundOpacity.toString(16),
                  position: "absolute",
                }}
              />
              {(shownDescription === "bottom" || showAdminInfo) &&
              selector === screenIndex &&
              screenIndex !== "none" &&
              document.getElementById("selectionRibbonContainer").clientWidth !== null ? (
                <ArrowDropDownIcon
                  style={
                    document.getElementById("selectionRibbonContainer").clientWidth < descriptionWidth
                      ? {
                          display: "none",
                        }
                      : document.getElementById("selectionRibbonContainer").clientWidth > descriptionWidth &&
                          showFilterReturnButton
                        ? {
                            transform: "translateY(" + (screens.screenHeight + 40) + "px) rotate(180deg)",
                            position: "fixed",
                            color: colorGroup1Background,
                            width: 108,
                            fontSize: 35,
                          }
                        : {
                            transform: "translateY(" + (screens.screenHeight + 10) + "px) rotate(180deg)",
                            position: "fixed",
                            color: colorGroup1Background,
                            width: 108,
                            fontSize: 35,
                          }
                  }
                />
              ) : null}
              {screenIndex === "none" && allSelectedFilterText !== "" && showAllText ? (
                <p
                  style={{
                    height: "100%",
                    color: "white",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    fontWeight: 700,
                    pointerEvents: "none",
                    textAlign: "center",
                  }}
                >
                  {allSelectedFilterText}
                </p>
              ) : null}
            </div>
            {showFilterReturnButton && screenIndex === selector ? (
              <ButtonGroup
                color={"primary"}
                size={"small"}
                style={{
                  width: "100%",
                  height: 30,
                  transform: "translateY(10px)",
                  boxShadow: "none",
                }}
                variant={"contained"}
              >
                {screenIndex !== "none" ? (
                  <Button
                    onClick={() => {
                      if (screenIndex.length > 1) {
                        selectorFunction(screenIndex.slice(0, -1));
                      } else {
                        selectorFunction("none");
                      }
                    }}
                    style={{
                      color: colorGroup1Foreground,
                      borderColor: colorGroup1Background,
                      backgroundColor: colorGroup1Background,
                    }}
                  >
                    <DoubleArrowRoundedIcon style={{ transform: "rotate(180deg)" }} />
                  </Button>
                ) : null}
                <Button
                  style={{
                    borderColor: colorGroup1Background,
                    backgroundColor: colorGroup1Foreground,
                    width: "100%",
                  }}
                  variant={"outlined"}
                >
                  {screenIndex === "none" ? <>No filter</> : <>Filter</>}
                </Button>
              </ButtonGroup>
            ) : null}
          </div>

          {shownDescription === "side" ? (
            <div style={{ zIndex: 0 }}>
              {screenIndex === selector && screenIndex !== "none" ? (
                <Typography
                  style={{
                    padding: 20,
                    width: screens.screenWidth * 2,
                    color: colorGroup2Foreground,
                    display: "grid",
                  }}
                >
                  {showAdminInfo ? <strong>[{screenIndex}]</strong> : null}
                  <TranslationWrapper
                    tDefault={screens.screenDescription}
                    tKey={`CustomComponents_SortingRibbon.${screens.screenDescription}`}
                  />
                </Typography>
              ) : null}
            </div>
          ) : null}
        </>
      ) : null}
      {screenExists
        ? screens.subScreenInfo.map((subScreens) => (
            <div key={subScreens.screenIndex} style={{ display: "flex" }}>
              <FilterRibbonFunction
                areaHighlightBackground={areaHighlightBackground}
                areaHighlightBackgroundOpacity={areaHighlightBackgroundOpacity}
                areaOpacity={areaOpacity}
                colorGroup1Background={colorGroup1Background}
                colorGroup1Foreground={colorGroup1Foreground}
                colorGroup2Background={colorGroup2Background}
                colorGroup2Foreground={colorGroup2Foreground}
                colorGroup3Background={colorGroup3Background}
                colorGroup3Foreground={colorGroup3Foreground}
                parentImg={parentImg}
                screenAmount={screenAmount}
                screens={subScreens}
                selector={selector}
                selectorFunction={selectorFunction}
                showAdminInfo={showAdminInfo}
                showFilterReturnButton={showFilterReturnButton}
                shownDescription={shownDescription}
              />
            </div>
          ))
        : null}
    </>
  );
}

function DescriptionComponent({
  screens,
  selector,
  showAdminInfo,
  colorGroup1Background,
  colorGroup1Foreground,
  screenAmount,
}) {
  const screenExists = screens.hasOwnProperty("subScreenInfo");
  let screenIndex = screens.screenIndex;
  // let descriptionWidth = screens.screenWidth * screenAmount + 10 * screenAmount;

  return (
    <>
      {screenIndex === selector && screenIndex !== "none" ? (
        <Typography
          style={{
            padding: 20,
            left: 0,
            marginBottom: 20,
            backgroundColor: colorGroup1Background,
            width: "100%", //descriptionWidth + 40
            color: colorGroup1Foreground,
            display: "flex",
          }}
        >
          {showAdminInfo ? <strong style={{ paddingRight: 5 }}>[{screenIndex}]</strong> : null}{" "}
          <TranslationWrapper
            tDefault={screens.screenDescription}
            tKey={`CustomComponents_SortingRibbon.${screens.screenDescription}`}
          />
        </Typography>
      ) : null}

      {screenExists
        ? screens.subScreenInfo.map((subScreens) => (
            <div key={subScreens.screenIndex}>
              <DescriptionComponent
                colorGroup1Background={colorGroup1Background}
                colorGroup1Foreground={colorGroup1Foreground}
                screenAmount={screenAmount}
                screens={subScreens}
                selector={selector}
                showAdminInfo={showAdminInfo}
              />
            </div>
          ))
        : null}
    </>
  );
}

function FilterRibbonBreadcrumbMenuComponent({ screens, selectorFunction, selector }) {
  const screenExists = screens.hasOwnProperty("subScreenInfo");
  let screenIndex = screens.screenIndex;

  return (
    <>
      {screenIndex === selector.substr(0, screenIndex.length) || screenIndex === "none" ? (
        <>
          {screenIndex !== "none" ? (
            <p style={{ color: "#f7844a", fontSize: "1rem", marginRight: 15, marginLeft: 15 }}> / </p>
          ) : null}
          <Link
            onClick={() => {
              selectorFunction(screens.screenIndex);
            }}
            style={{ fontSize: "1rem", cursor: "pointer" }}
          >
            {screens.screenTitle}
          </Link>
        </>
      ) : null}
      {screenExists
        ? screens.subScreenInfo.map((subScreens) => (
            <div key={subScreens.screenIndex} style={{ display: "flex" }}>
              <FilterRibbonBreadcrumbMenuComponent
                screens={subScreens}
                selector={selector}
                selectorFunction={selectorFunction}
              />
            </div>
          ))
        : null}
    </>
  );
}
